module.exports = __webpack_public_path__ + "img/icon_menu_user.cfd1cf0f.svg";